module.exports = "/images/product-service-sales-funnels.svg?1952e67747d52cff817ab7d1e872f250";